module.exports = __webpack_public_path__ + "media/images/matchdaySelector__prev-05c4f9b9d7dc167b96f8c70afdebc10f.png";